export const i18nTemplateString = (s: string, replacer: (s: string) => any | string): string =>
  s &&
  s.replace(
    /({i18n\.[\w.]*})/gi,
    (x: string) => replacer(x.replace('{i18n.', '').replace('}', '')), // gets the i18n string
  );
